import React from 'react';
import { IconProps } from '.';

const SvgZdsBeachwear = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 32 32'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m12.435 7.193-.764-1.528-1.342.67.785 1.57c-4.058 2.59-5.653 7.679-3.927 12.07.18.46.398.914.653 1.355l8.15-4.705 3.894 7.01c-.167-.09-.336-.186-.512-.286l-.037-.021c-.861-.493-1.885-1.078-3.335-1.078s-2.474.585-3.335 1.078l-.037.02c-.88.504-1.598.902-2.628.902-.516 0-.874-.101-1.16-.239-.302-.145-.551-.34-.871-.597l-.021-.016c-.301-.241-.67-.537-1.14-.762C6.315 22.4 5.735 22.25 5 22.25v1.5c.516 0 .874.101 1.16.239.302.145.551.34.871.597l.021.016c.301.241.67.537 1.14.762.494.237 1.074.386 1.808.386 1.45 0 2.474-.585 3.335-1.078l.037-.02c.88-.504 1.598-.902 2.628-.902s1.747.398 2.628.901l.037.021c.861.493 1.885 1.078 3.335 1.078.734 0 1.314-.149 1.809-.386.468-.225.838-.52 1.139-.762l.02-.016c.32-.256.57-.452.872-.597.286-.138.644-.239 1.16-.239v-1.5c-.734 0-1.314.149-1.809.386-.468.225-.838.52-1.139.762l-.02.016c-.32.256-.57.452-.872.597-.286.138-.644.239-1.16.239h-.059l-4.652-8.375 7.871-4.545a10.005 10.005 0 0 0-12.725-4.137Zm-1.53 2.736a8.509 8.509 0 0 0-2.402 9.286l3.572-2.062c-.78-1.447-1.179-3.054-1.291-4.534-.072-.943-.03-1.868.121-2.69Zm2.47 6.474 5.315-3.07C16.813 10.697 14.3 9.52 12.744 9c-.363.765-.576 2.036-.464 3.507.098 1.297.445 2.676 1.095 3.897Zm1.112-8.333c1.694.753 3.835 2.102 5.507 4.51l3.003-1.733a8.512 8.512 0 0 0-8.51-2.777Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgZdsBeachwear;
